<template>
  <div class="maintenance-banner">
    <v-icon class="alert-icon" color="#D66C00">mdi-alert-circle-outline</v-icon>
    <p>
      <strong>Maintenance in progress.</strong>
      Some features may be unavailable. Please check our
      <a href="https://trust.loadsmart.com/" target="_blank">status page</a>
      for more information.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceBanner'
};
</script>

<style scoped>
.maintenance-banner {
  background-color: #ffeed9;
  color: #333;
  padding: 16px;
  text-align: center;
  width: 100%;
  border-bottom: 2px solid #d66c00;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.alert-icon {
  flex-shrink: 0;
}

.maintenance-banner p {
  margin: 0;
  line-height: 1.4;
}

.maintenance-banner a {
  color: inherit;
  text-decoration: underline;
}
</style>
